import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class SavePageViewHitTrackingService extends UseCase {
  constructor({config, httpTrackingRepository}) {
    super()
    this._config = config
    this._httpTrackingRepository = httpTrackingRepository
  }
  /**
   * @method
   * @return {Promise}
   */

  @inlineError
  execute(pageViewHitVO) {
    return this._httpTrackingRepository.savePageViewHit(pageViewHitVO).then(([error]) => {
      if (error) return Promise.reject(error)
      return Promise.resolve()
    })
  }
}
